// www.npmjs.com/package/applicationinsights#track-custom-telemetry
import jwtDecode from "jwt-decode";
import appConfig from "../../app-config";
import { TokenStorage } from "../storage";

var extend = require("extend");
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appConfig.VUE_APP_TELEMETRY_KEY,
    /* ...Other Configuration Options... */
  },
});

const token = TokenStorage.getToken();

let userName = "";

try {
  var decoded = jwtDecode(token);
  userName =
    decoded[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ];
  // eslint-disable-next-line no-empty
} catch {}

function GetCustomProperties() {
  return {
    Application: "gcorp-web-app",
    Origin: window.location.origin,
    Host: window.location.host,
    PathName: window.location.pathname,
    Username: userName,
    Tenant: TokenStorage.getTenant(),
  };
}

const AppInsightsService = {
  init() {
    if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
      appInsights.loadAppInsights();
    }
  },
  trackInfoEvent(params) {
    if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
      let props = {};
      extend(props, params.properties, GetCustomProperties(), {
        Level: "INFO",
      });
      appInsights.trackEvent({
        name: params.name,
        properties: props,
      });
    }
  },
  trackWarningEvent(params) {
    if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
      let props = {};
      extend(props, params.properties, GetCustomProperties(), {
        Level: "WARNING",
      });
      appInsights.trackEvent({
        name: params.name,
        properties: props,
      });
    }
  },
  trackErrorEvent(params) {
    if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
      let props = {};
      extend(props, params.properties, GetCustomProperties(), {
        Level: "WARNING",
      });
      appInsights.trackEvent({
        name: params.name,
        properties: props,
      });
    }
  },
  // trackException(params) {
  //   if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
  //     appInsights.trackException({
  //       exception: new Error(params.exception),
  //     });
  //   }
  // },
  // trackMetric(params) {
  //   if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
  //     appInsights.trackMetric({ name: params.name, value: params.value });
  //   }
  // },
  // trackTrace(params) {
  //   if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
  //     appInsights.trackTrace({ message: params.message });
  //   }
  // },
  // trackDependency(params) {
  //   if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
  //     appInsights.trackDependency({
  //       target: params.target,
  //       name: params.name,
  //       data: params.data,
  //       duration: params.duration,
  //       resultCode: params.resultCode,
  //       success: params.success,
  //       dependencyTypeName: params.dependencyTypeName,
  //     });
  //   }
  // },
  // trackRequest(params) {
  //   if (appConfig.VUE_APP_TELEMETRY_ENABLED) {
  //     appInsights.trackRequest({
  //       name: params.name,
  //       url: params.url,
  //       duration: params.duration,
  //       resultCode: params.resultCode,
  //       success: params.success,
  //     });
  //   }
  // },
};

export { AppInsightsService };
